@if (!expanded()) {
  <a class="load-more fake-link" (click)="expand()" i18n>load more</a>
}
<ng-container #content />
